import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import NotificationsOutlinedIcon from "@material-ui/icons/NotificationsNoneOutlined";
import { Drawer } from "@material-ui/core";

const useStyles = makeStyles({
  container: {
    width: "100%",
    height: "100vh",
    overflow: "auto",
  },
  drawer: {
    width: "300px",
  },
  drawerPaper: {
    width: "350px",
    background: "#FFFAF5",
  },
  notificationHeader: {
    display: "flex",
    alignItems: "center",
    // justifyContent: "space-around",
    marginBottom: "20px",
  },
  notificationTitle: {
    color: "#3D3D3D",
    fontSize: "16px",
    fontWeight: "500",
    fontFamily: "Roboto",
    // marginLeft: "8px",
  },
  profileContainer: {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    background: "#FFFDFA",
    boxShadow: "0px 1px 2px 0px #FBE2C6",
    border: "1px solid #FDECD9",
    borderRadius: "8px",
    fontFamily: "Roboto",
    marginBottom: "24px",
  },
});

const NotificationsDrawer = ({
  isNotificationDrawerOpen,
  toggleNotificationDrawer,
  notificationsList,
}) => {
  const classes = useStyles();
  const emailRef = useRef();
  const passwordRef = useRef();
  const logoRef = useRef(null);
  const history = useHistory();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [banner, setBanner] = useState([]);
  const [pendingNotifications, setPendingNotifications] = useState(0);
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [demos, setDemos] = useState(false);

  return (
    <>
      <Drawer
        anchor="left"
        open={isNotificationDrawerOpen}
        onClose={() => toggleNotificationDrawer(false)}
        className={classes.drawer}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Grid container style={{ padding: "0px 16px" }}>
          <Grid item xs={12} className={classes.notificationHeader}>
            <IconButton onClick={() => toggleNotificationDrawer(false)}>
              <NotificationsOutlinedIcon
                style={{
                  fontSize: "24px",
                  color: "#3D3D3D",
                  fontWeight: "500",
                }}
              />
            </IconButton>
            <div className={classes.notificationTitle}>Notifications</div>
            <IconButton
              onClick={() => toggleNotificationDrawer(false)}
              style={{ marginLeft: "auto" }}
            >
              <CloseIcon
                style={{
                  fontSize: "24px",
                  color: "#3D3D3D",
                  fontWeight: "500",
                }}
              />
            </IconButton>
          </Grid>
          <Grid item xs={12}>
            {notificationsList &&
              notificationsList.map((notification) => (
                <div className={classes.profileContainer}>
                  {notification.notificationContent.title}
                </div>
              ))}
          </Grid>
        </Grid>
      </Drawer>
    </>
  );
};

export default NotificationsDrawer;
